/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { FieldError } from "react-hook-form";
import { Description, Input, Label } from "@nordcloud/gnui";
import { Fieldset } from "../Fieldset";

type Props = {
  label: string;
  error?: FieldError;
} & React.ComponentPropsWithoutRef<typeof Input>;

export const InputField = React.forwardRef<HTMLInputElement, Props>(
  (
    { id, label, error, type = "text", required, placeholder, ...props },
    ref
  ) => (
    <Fieldset>
      <Label htmlFor={id} name={label} required={required} />
      <Input
        id={id}
        type={type}
        status={error ? "danger" : "success"}
        placeholder={placeholder || label}
        ref={ref}
        {...props}
      />
      {error && <Description>{error.message}</Description>}
    </Fieldset>
  )
);
